// Demo data for dynamic status analytics tables
// Contains sample data for Connected Calls, Unreached Calls, and Other Status tables
// Organized by year and month for date-based filtering

export const statusAnalyticsData = {
  2025: {
    1: {
      connectedCalls: [
        {
          serialNo: 1,
          callStatus: "Call Done",
          newRegistration: 1250,
          recentlyDelivered: 980,
          followUp: 270,
          total: 2500
        },
        {
          serialNo: 2,
          callStatus: "Call Incomplete",
          newRegistration: 850,
          recentlyDelivered: 620,
          followUp: 180,
          total: 1650
        },
        {
          serialNo: 3,
          callStatus: "Declined",
          newRegistration: 420,
          recentlyDelivered: 320,
          followUp: 90,
          total: 830
        },
        {
          serialNo: 4,
          callStatus: "Deceased Child",
          newRegistration: 180,
          recentlyDelivered: 150,
          followUp: 45,
          total: 375
        },
        {
          serialNo: 5,
          callStatus: "Miscarriage",
          newRegistration: 220,
          recentlyDelivered: 180,
          followUp: 55,
          total: 455
        },
        {
          serialNo: 6,
          callStatus: "Not Pregnant",
          newRegistration: 340,
          recentlyDelivered: 280,
          followUp: 75,
          total: 695
        },
        {
          serialNo: 7,
          callStatus: "Deceased Mother",
          newRegistration: 95,
          recentlyDelivered: 80,
          followUp: 25,
          total: 200
        },
        {
          serialNo: 8,
          callStatus: "Deceased (Mother and Child)",
          newRegistration: 45,
          recentlyDelivered: 38,
          followUp: 12,
          total: 95
        },
        {
          serialNo: 9,
          callStatus: "Wrong Number",
          newRegistration: 580,
          recentlyDelivered: 450,
          followUp: 125,
          total: 1155
        }
      ],
      unreachedCalls: [
        {
          serialNo: 1,
          callStatus: "Busy",
          newRegistration: 1850,
          recentlyDelivered: 1420,
          followUp: 380,
          total: 3650
        },
        {
          serialNo: 2,
          callStatus: "No Answer",
          newRegistration: 2100,
          recentlyDelivered: 1680,
          followUp: 450,
          total: 4230
        },
        {
          serialNo: 3,
          callStatus: "No Network",
          newRegistration: 890,
          recentlyDelivered: 720,
          followUp: 195,
          total: 1805
        },
        {
          serialNo: 4,
          callStatus: "Incoming not available",
          newRegistration: 1250,
          recentlyDelivered: 980,
          followUp: 270,
          total: 2500
        },
        {
          serialNo: 5,
          callStatus: "Switched Off",
          newRegistration: 1680,
          recentlyDelivered: 1320,
          followUp: 360,
          total: 3360
        },
        {
          serialNo: 6,
          callStatus: "Invalid",
          newRegistration: 520,
          recentlyDelivered: 420,
          followUp: 110,
          total: 1050
        },
        {
          serialNo: 7,
          callStatus: "Out of Service",
          newRegistration: 780,
          recentlyDelivered: 620,
          followUp: 165,
          total: 1565
        },
        {
          serialNo: 8,
          callStatus: "Language Barrier",
          newRegistration: 340,
          recentlyDelivered: 280,
          followUp: 75,
          total: 695
        },
        {
          serialNo: 9,
          callStatus: "Duplicate MotherId",
          newRegistration: 280,
          recentlyDelivered: 220,
          followUp: 60,
          total: 560
        }
      ],
      otherStatus: [
        {
          serialNo: 1,
          callStatus: "Child Above 2 Years",
          newRegistration: 1580,
          recentlyDelivered: 1250,
          followUp: 330,
          total: 3160
        },
        {
          serialNo: 2,
          callStatus: "Not in the portal",
          newRegistration: 920,
          recentlyDelivered: 750,
          followUp: 195,
          total: 1865
        }
      ]
    },
    2: {
      connectedCalls: [
        {
          serialNo: 1,
          callStatus: "Call Done",
          newRegistration: 1380,
          recentlyDelivered: 1050,
          followUp: 295,
          total: 2725
        },
        {
          serialNo: 2,
          callStatus: "Call Incomplete",
          newRegistration: 920,
          recentlyDelivered: 680,
          followUp: 195,
          total: 1795
        },
        {
          serialNo: 3,
          callStatus: "Declined",
          newRegistration: 480,
          recentlyDelivered: 365,
          followUp: 105,
          total: 950
        },
        {
          serialNo: 4,
          callStatus: "Deceased Child",
          newRegistration: 195,
          recentlyDelivered: 165,
          followUp: 50,
          total: 410
        },
        {
          serialNo: 5,
          callStatus: "Miscarriage",
          newRegistration: 245,
          recentlyDelivered: 195,
          followUp: 60,
          total: 500
        },
        {
          serialNo: 6,
          callStatus: "Not Pregnant",
          newRegistration: 380,
          recentlyDelivered: 310,
          followUp: 85,
          total: 775
        },
        {
          serialNo: 7,
          callStatus: "Deceased Mother",
          newRegistration: 105,
          recentlyDelivered: 88,
          followUp: 28,
          total: 221
        },
        {
          serialNo: 8,
          callStatus: "Deceased (Mother and Child)",
          newRegistration: 52,
          recentlyDelivered: 42,
          followUp: 14,
          total: 108
        },
        {
          serialNo: 9,
          callStatus: "Wrong Number",
          newRegistration: 640,
          recentlyDelivered: 495,
          followUp: 140,
          total: 1275
        }
      ],
      unreachedCalls: [
        {
          serialNo: 1,
          callStatus: "Busy",
          newRegistration: 1950,
          recentlyDelivered: 1480,
          followUp: 410,
          total: 3840
        },
        {
          serialNo: 2,
          callStatus: "No Answer",
          newRegistration: 2200,
          recentlyDelivered: 1750,
          followUp: 485,
          total: 4435
        },
        {
          serialNo: 3,
          callStatus: "No Network",
          newRegistration: 920,
          recentlyDelivered: 750,
          followUp: 205,
          total: 1875
        },
        {
          serialNo: 4,
          callStatus: "Incoming not available",
          newRegistration: 1320,
          recentlyDelivered: 1020,
          followUp: 285,
          total: 2625
        },
        {
          serialNo: 5,
          callStatus: "Switched Off",
          newRegistration: 1750,
          recentlyDelivered: 1380,
          followUp: 385,
          total: 3515
        },
        {
          serialNo: 6,
          callStatus: "Invalid",
          newRegistration: 580,
          recentlyDelivered: 465,
          followUp: 125,
          total: 1170
        },
        {
          serialNo: 7,
          callStatus: "Out of Service",
          newRegistration: 820,
          recentlyDelivered: 650,
          followUp: 175,
          total: 1645
        },
        {
          serialNo: 8,
          callStatus: "Language Barrier",
          newRegistration: 380,
          recentlyDelivered: 310,
          followUp: 85,
          total: 775
        },
        {
          serialNo: 9,
          callStatus: "Duplicate MotherId",
          newRegistration: 320,
          recentlyDelivered: 250,
          followUp: 70,
          total: 640
        }
      ],
      otherStatus: [
        {
          serialNo: 1,
          callStatus: "Child Above 2 Years",
          newRegistration: 1680,
          recentlyDelivered: 1320,
          followUp: 360,
          total: 3360
        },
        {
          serialNo: 2,
          callStatus: "Not in the portal",
          newRegistration: 980,
          recentlyDelivered: 795,
          followUp: 210,
          total: 1985
        }
      ]
    }
  },
  2024: {
    12: {
      connectedCalls: [
        {
          serialNo: 1,
          callStatus: "Call Done",
          newRegistration: 1180,
          recentlyDelivered: 920,
          followUp: 250,
          total: 2350
        },
        {
          serialNo: 2,
          callStatus: "Call Incomplete",
          newRegistration: 780,
          recentlyDelivered: 580,
          followUp: 165,
          total: 1525
        },
        {
          serialNo: 3,
          callStatus: "Declined",
          newRegistration: 380,
          recentlyDelivered: 295,
          followUp: 80,
          total: 755
        },
        {
          serialNo: 4,
          callStatus: "Deceased Child",
          newRegistration: 165,
          recentlyDelivered: 135,
          followUp: 40,
          total: 340
        },
        {
          serialNo: 5,
          callStatus: "Miscarriage",
          newRegistration: 195,
          recentlyDelivered: 160,
          followUp: 45,
          total: 400
        },
        {
          serialNo: 6,
          callStatus: "Not Pregnant",
          newRegistration: 310,
          recentlyDelivered: 250,
          followUp: 65,
          total: 625
        },
        {
          serialNo: 7,
          callStatus: "Deceased Mother",
          newRegistration: 85,
          recentlyDelivered: 72,
          followUp: 20,
          total: 177
        },
        {
          serialNo: 8,
          callStatus: "Deceased (Mother and Child)",
          newRegistration: 40,
          recentlyDelivered: 33,
          followUp: 10,
          total: 83
        },
        {
          serialNo: 9,
          callStatus: "Wrong Number",
          newRegistration: 520,
          recentlyDelivered: 405,
          followUp: 110,
          total: 1035
        }
      ],
      unreachedCalls: [
        {
          serialNo: 1,
          callStatus: "Busy",
          newRegistration: 1720,
          recentlyDelivered: 1320,
          followUp: 350,
          total: 3390
        },
        {
          serialNo: 2,
          callStatus: "No Answer",
          newRegistration: 1950,
          recentlyDelivered: 1580,
          followUp: 420,
          total: 3950
        },
        {
          serialNo: 3,
          callStatus: "No Network",
          newRegistration: 820,
          recentlyDelivered: 680,
          followUp: 180,
          total: 1680
        },
        {
          serialNo: 4,
          callStatus: "Incoming not available",
          newRegistration: 1150,
          recentlyDelivered: 920,
          followUp: 250,
          total: 2320
        },
        {
          serialNo: 5,
          callStatus: "Switched Off",
          newRegistration: 1580,
          recentlyDelivered: 1250,
          followUp: 335,
          total: 3165
        },
        {
          serialNo: 6,
          callStatus: "Invalid",
          newRegistration: 480,
          recentlyDelivered: 395,
          followUp: 105,
          total: 980
        },
        {
          serialNo: 7,
          callStatus: "Out of Service",
          newRegistration: 720,
          recentlyDelivered: 580,
          followUp: 155,
          total: 1455
        },
        {
          serialNo: 8,
          callStatus: "Language Barrier",
          newRegistration: 320,
          recentlyDelivered: 265,
          followUp: 70,
          total: 655
        },
        {
          serialNo: 9,
          callStatus: "Duplicate MotherId",
          newRegistration: 250,
          recentlyDelivered: 195,
          followUp: 55,
          total: 500
        }
      ],
      otherStatus: [
        {
          serialNo: 1,
          callStatus: "Child Above 2 Years",
          newRegistration: 1450,
          recentlyDelivered: 1150,
          followUp: 305,
          total: 2905
        },
        {
          serialNo: 2,
          callStatus: "Not in the portal",
          newRegistration: 850,
          recentlyDelivered: 695,
          followUp: 180,
          total: 1725
        }
      ]
    }
  }
};

// Helper function to get data for a specific month/year and table type
export const getTableData = (year, month, tableType) => {
  const monthData = statusAnalyticsData[year]?.[month];
  if (!monthData) {
    return [];
  }
  return monthData[tableType] || [];
};

// Table configuration for each table type
export const tableConfigs = {
  connectedCalls: {
    title: "Connected Calls",
    dataKey: "connectedCalls",
    sortable: true
  },
  unreachedCalls: {
    title: "Unreached Calls", 
    dataKey: "unreachedCalls",
    sortable: true
  },
  otherStatus: {
    title: "Other Status",
    dataKey: "otherStatus",
    sortable: true
  }
};

// Column definitions for all tables
export const columnDefinitions = [
  { 
    id: 'serialNo', 
    label: 'Serial No.', 
    numeric: true, 
    sortable: true,
    align: 'center' 
  },
  { 
    id: 'callStatus', 
    label: 'Call Status', 
    numeric: false, 
    sortable: true,
    align: 'left' 
  },
  { 
    id: 'newRegistration', 
    label: 'New Registration', 
    numeric: true, 
    sortable: true,
    align: 'right' 
  },
  { 
    id: 'recentlyDelivered', 
    label: 'Recently Delivered', 
    numeric: true, 
    sortable: true,
    align: 'right' 
  },
  { 
    id: 'followUp', 
    label: 'Follow-up', 
    numeric: true, 
    sortable: true,
    align: 'right' 
  },
  { 
    id: 'total', 
    label: 'Total', 
    numeric: true, 
    sortable: true,
    align: 'right' 
  }
];

// Helper function to calculate totals for each column
export const calculateTotals = (data) => {
  return data.reduce((totals, row) => {
    totals.newRegistration += row.newRegistration;
    totals.recentlyDelivered += row.recentlyDelivered;
    totals.followUp += row.followUp;
    totals.total += row.total;
    return totals;
  }, {
    serialNo: '',
    callStatus: 'TOTAL',
    newRegistration: 0,
    recentlyDelivered: 0,
    followUp: 0,
    total: 0
  });
};

// Sort function for dynamic table
export const sortData = (data, orderBy, order) => {
  return data.slice().sort((a, b) => {
    let aVal = a[orderBy];
    let bVal = b[orderBy];
    
    // Handle numeric sorting
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return order === 'desc' ? bVal - aVal : aVal - bVal;
    }
    
    // Handle string sorting
    aVal = aVal.toString().toLowerCase();
    bVal = bVal.toString().toLowerCase();
    
    if (order === 'desc') {
      return bVal.localeCompare(aVal);
    }
    return aVal.localeCompare(bVal);
  });
};
